import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { NavItem } from "shards-react";

const SidebarNavItem = ({ item, onClick }) => (
  <NavItem>
    <NavLink to={item.to} exact={item.exact} className="nav-link" onClick={onClick}>
      {item.htmlBefore && (
        <div
          className="d-inline-block item-icon-wrapper"
          dangerouslySetInnerHTML={{ __html: item.htmlBefore }}
        />
      )}
      {item.title && <span>{item.title}</span>}
      {item.htmlAfter && (
        <div
          className="d-inline-block item-icon-wrapper"
          dangerouslySetInnerHTML={{ __html: item.htmlAfter }}
        />
      )}
    </NavLink>
  </NavItem>
);

SidebarNavItem.propTypes = {
  item: PropTypes.object
};

export default SidebarNavItem;
